import { useReducer } from "react";
import axios from "axios";

import { store } from "../../store";

const initialState = {
  status: "idle",
  response: null,
  error: null,
};

function reducer(state, action) {
  const newState = { ...state };

  switch (action.type) {
    case "PENDING":
      newState.status = "loading";
      newState.response = null;
      newState.error = null;
      return newState;
    case "SUCCESS":
      newState.response = action.data;
      newState.status = "success";
      return newState;
    case "ERROR":
      newState.error = action.error;
      newState.status = "error";
      return newState;
    default:
      return state;
  }
}

export default function useChatApi(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  function sendPrompt(prompt) {
    dispatch({ type: "PENDING" });
    if (store.getState().app_token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${store.getState().app_token.accessToken}`;
    }
    axios
      .get(`/__api/v1/plans/${props.planId}/query?q=${prompt}`)
      .then(({ data }) => {
        dispatch({ type: "SUCCESS", data });
        props.onSuccess(data);
      })
      .catch((error) => {
        dispatch({ type: "ERROR", error: error.response });
        props.onError(error.response);
      });
  }

  const isLoading = state.status === "loading";

  return [{ ...state, isLoading }, sendPrompt];
}



// WEBPACK FOOTER //
// ./src/components/chatbot/chatbot.service.js